<template>
  <div class="machine-list">
    <add-machine
      :addOrEdit="addOrEdit"
      :machine="machine"
      :dialogMachine="dialogMachine"
      :machineType="machineType"
      :machineGroup="machineGroup"
      :appTypeList="appTypeList"
      :machineVersion="machineVersion"
      v-on:cancel="cancel"
    >
    </add-machine>
    <!-- :appVersion="appVersion" -->
    <search-machine
      :search="search"
      :yesNo="yesNo"
      :appTypeList="appTypeList"
      :multipleSelection="multipleSelection"
      :machineType="machineType"
      :machineGroup="machineGroup"
      v-on:importSuccess="importSuccess"
      v-on:addMachine="addMachine"
      v-on:recoverMachine="recoverMachine"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      v-on:quickAddMachine="handlerQuickAddMachine"
    >
    </search-machine>
    <dialog-quick-add-machine
      :dialogQuickAddMachine="dialogQuickAddMachine"
      :machineType="machineType"
      :machineGroup="machineGroup"
      v-on:cancel="cancelQuickAddMachine"
      v-on:refresh="currentChange"
      v-on:refreshGroup="listMachineGroup"
    >
    </dialog-quick-add-machine>
    <div v-if="dialogExtend" class="extend-modal-overlay">
      <div class="extend-modal-box">
        <div class="extend-modal-header">
          <span>Extend Subscription</span>
          <span class="extend-modal-close" @click="dialogExtend = false">✕</span>
        </div>
        <div class="extend-modal-body">
          <div style="margin-bottom:16px;font-size:14px;color:var(--vtm-ink)">
            <b>Machine:</b> {{ extendTarget.equipmentName }} ({{ extendTarget.equipmentNo }})
          </div>
          <div style="margin-bottom:8px;font-size:14px;color:var(--vtm-ink-2)">New Expiry Date</div>
          <div style="display:flex;gap:8px">
            <input v-model="extendDatePart" type="date" class="extend-date-input" style="width:150px" @change="onDatePartChange" />
            <input v-model="extendTimePart" type="time" step="1" class="extend-date-input" style="width:120px" @change="onDatePartChange" />
          </div>
          <div v-if="extendDate" style="margin-top:8px;font-size:12px;color:var(--vtm-ok)">Set to: {{ extendDate }}</div>
        </div>
        <div class="extend-modal-footer">
          <button class="extend-btn-cancel" @click="dialogExtend = false">Cancel</button>
          <button class="extend-btn-confirm" :disabled="!extendDate || extendLoading" @click="confirmExtend">
            {{ extendLoading ? 'Saving...' : 'Confirm' }}
          </button>
        </div>
      </div>
    </div>

    <div class="user-main vue-padding">
      <el-table
        v-loading="loading"
        ref="machineTable"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="machineList"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column type="selection" :selectable="selectable" width="40" :align="'center'"></el-table-column>
        <el-table-column prop="mqState" :label="$t('machineUser.online')" width="65" :align="'center'">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.mqState && scope.row.mqState == 0"
              style="width: 10px; height: 10px"
              :src="require('_as/zaixian.png')"
              fit="fill"
            ></el-image>
            <el-image
              v-if="scope.row.mqState && scope.row.mqState == 1"
              style="width: 10px; height: 10px"
              :src="require('_as/lixian.png')"
              fit="fill"
            ></el-image>
            <div
              v-if="!scope.row.mqState"
              style="
                width: 10px;
                height: 10px;
                background-color: var(--vtm-line);
                border-radius: 100%;
                margin: 0 auto;
                border: 2px solid var(--vtm-ink-2);
              "
            ></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="teamName"
          :show-overflow-tooltip="true"
          :label="$t('machine.teamName')"
          width="130"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="userName" :label="$t('admin.Machine.476040-0')" width="180" :align="'center'">
          <template #default="scope">
            {{ scope.row.userName ? scope.row.userName : "Unallocated" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="typeName"
          :label="$t('machine.typeName')"
          width="155"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('machine.equipmentNo')"
          width="140"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('machine.name')"
          width="170"
          :align="'center'"
        ></el-table-column>
        <!-- <el-table-column
					prop="apkVersion"
					:label="$t('machine.appVersionName')"
					width="110"
					:align="'center'"
				></el-table-column> -->

        <el-table-column :label="$t('machine.wtiSerial')" width="210" :align="'center'">
          <template slot-scope="scope">
            <span>{{ scope.row.wtiSerialNumber || "—" }}</span>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="editWtiSerial(scope.row)"
            ></el-button>
            <el-button
              v-if="scope.row.wtiSerialNumber"
              type="text"
              size="mini"
              :loading="wtiPinging === scope.row.wtiSerialNumber"
              @click="wtiPing(scope.row)"
            >{{ $t("machine.ping") }}</el-button>
            <el-button
              v-if="scope.row.wtiSerialNumber"
              type="text"
              size="mini"
              :loading="wtiRebooting === scope.row.wtiSerialNumber"
              @click="wtiReboot(scope.row)"
            >{{ $t("machine.reboot") }}</el-button>
            <div
              v-if="scope.row.wtiSerialNumber && wtiInfoMap[scope.row.wtiSerialNumber]"
              style="font-size: 12px; color: #909399; line-height: 1.2;"
            >
              {{ wtiInfoMap[scope.row.wtiSerialNumber].description || "—" }}
              <el-button
                type="text"
                size="mini"
                icon="el-icon-edit"
                :title="$t('machine.wtiDescription')"
                @click="editWtiDescription(scope.row)"
              ></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('machine.simUsage')" width="150" :align="'center'">
          <template slot-scope="scope">
            <span v-if="!scope.row.wtiSerialNumber">—</span>
            <span v-else-if="wtiInfoMap[scope.row.wtiSerialNumber] === undefined">
              <i class="el-icon-loading"></i>
            </span>
            <span v-else-if="!wtiSims(scope.row).length">—</span>
            <div v-else v-for="sim in wtiSims(scope.row)" :key="sim.number">
              {{ sim.carrier || "SIM" + sim.slot }}: {{ sim.usageMb != null ? sim.usageMb : "—" }} MB
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('machine.simStatus')" width="210" :align="'center'">
          <template slot-scope="scope">
            <span v-if="!scope.row.wtiSerialNumber">—</span>
            <span v-else-if="wtiInfoMap[scope.row.wtiSerialNumber] === undefined">
              <i class="el-icon-loading"></i>
            </span>
            <span v-else-if="!wtiSims(scope.row).length">—</span>
            <div v-else v-for="sim in wtiSims(scope.row)" :key="sim.number" style="white-space: nowrap;">
              <el-tag
                :type="sim.status === 'Active' || (sim.esim && sim.inUse) ? 'success' : 'warning'"
                size="mini"
              >{{ sim.esim ? "eSIM" : sim.carrier || "SIM" + sim.slot }}: {{ sim.status || (sim.esim ? (sim.inUse ? $t("machine.simInUse") : "—") : "?") }}</el-tag>
              <template v-if="sim.esim">
                <el-button
                  type="text"
                  size="mini"
                  style="margin-left: 4px;"
                  @click="wtiEsimAction(scope.row, sim, 'activate')"
                >{{ $t("machine.simActivate") }}</el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="wtiEsimAction(scope.row, sim, 'deactivate')"
                >{{ $t("machine.simDeactivate") }}</el-button>
              </template>
              <el-button
                v-else
                type="text"
                size="mini"
                style="margin-left: 4px;"
                @click="wtiSimAction(scope.row, sim)"
              >{{ sim.status === "Active" ? $t("machine.simDeactivate") : $t("machine.simActivate") }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="notes"
          :show-overflow-tooltip="true"
          :label="$t('machine.notes')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
          :label="$t('machine.createTime')"
          :align="'center'"
          width="170px"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :align="'center'"
          :width="$i18n.locale == 'zh_CN' ? 260 : 300"
        >
          <template slot-scope="scope">
            <el-button size="mini" v-hasPerm="['machine:update']" @click="editMachine(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button type="warning" size="mini" v-hasPerm="['*:*:*']" @click="openExtendDialog(scope.row)">Extend</el-button>
            <span v-if="scope.row.sell === 0">
              <el-button type="danger" v-hasPerm="['machine:delete']" size="mini" @click="delMachine(scope.row)">{{
                $t("common.delete")
              }}</el-button>
            </span>
            <span v-else>
              <el-tag type="success" style="margin-left:4px">{{ $t("machine.sold") }}</el-tag>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="machineList.length > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import addMachine from "_c/machine/admin/AddMachine";
  import searchMachine from "_c/machine/admin/SearchMachine";
  import DialogQuickAddMachine from "./components/DialogQuickAddMachine";
  export default {
    name: "MachineList",
    components: {
      addMachine,
      searchMachine,
      DialogQuickAddMachine
    },
    data() {
      return {
        loading: false,
        machineList: [],
        wtiInfoMap: {},
        wtiPinging: null,
        wtiRebooting: null,
        machine: {
          apkId: "",
          teamId: "",
          typeId: "",
          equipmentNo: "",
          appVersion: "",
          equipmentName: "",
          notes: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        search: {
          teamId: "",
          typeId: "",
          equipmentNo: "",
          sell: "",
          equipmentName: ""
        },
        multipleSelection: [],
        machineTypeList: [],
        appTypeList: [],
        yesNo: [],
        dialogMachine: false,
        addOrEdit: false,
        machineType: [],
        machineGroup: [],
        // appVersion: [],
        machineVersion: [],
        dialogQuickAddMachine: false,
        dialogExtend: false,
        extendTarget: { equipmentNo: "", equipmentName: "" },
        extendDate: null,
        extendDatePart: "",
        extendTimePart: "00:00:00",
        extendLoading: false
      };
    },
    mounted() {
      this.currentChange();
      this.listMachineTypeList();
      this.listAppType();
      this.listMachineType();
      this.listMachineGroup();
      // this.listAppVersion();
      this.listMachineVersion();
    },
    methods: {
      // 快捷创建设备
      handlerQuickAddMachine() {
        this.dialogQuickAddMachine = true;
      },
      cancelQuickAddMachine() {
        this.dialogQuickAddMachine = false;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      selectable(row) {
        return row.sell !== 0;
      },
      listMachineTypeList() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            this.yesNo = res.data;
          }
        });
      },
      listAppType() {
        this.$api.dict("sys_app_type").then(res => {
          if (res.code === 0) {
            this.appTypeList = res.data;
          }
        });
      },
      listMachineType() {
        this.$api.request(this.$url.MachineType.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineType = res.data;
          }
        });
      },
      listMachineGroup() {
        this.$api.request(this.$url.MachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      // listAppVersion() {
      // 	this.$api
      // 		.request(this.$url.AppVersion.listAppVersion, this.$method.get, {
      // 			type: 1,
      // 		})
      // 		.then(res => {
      // 			if (res.code === 0) {
      // 				this.appVersion = res.data;
      // 			}
      // 		});
      // },
      listMachineVersion() {
        this.$api.dict("machine_version").then(res => {
          if (res.code === 0) {
            this.machineVersion = res.data;
          }
        });
      },

      appType(row) {
        return this.$cloud.getDictLabel(this.appTypeList, row.appType);
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.Machine.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.machineList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
              this.loadWtiInfo();
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      wtiSims(row) {
        const info = this.wtiInfoMap[row.wtiSerialNumber];
        return (info && info.sims) || [];
      },
      wtiPing(row) {
        const sn = row.wtiSerialNumber;
        this.wtiPinging = sn;
        this.$api
          .request(this.$url.Machine.wtiPing, this.$method.get, { sn: sn })
          .then(res => {
            this.wtiPinging = null;
            if (res.code === 0 && res.data && res.data.length) {
              const esc = s => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
              this.$alert(res.data.map(esc).join("<br>"), `Ping ${sn}`, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t("common.definite")
              });
            } else {
              this.$message.error(res.msg || this.$t("machine.pingFailed"));
            }
          })
          .catch(() => {
            this.wtiPinging = null;
            this.$message.error(this.$t("machine.pingFailed"));
          });
      },
      wtiReboot(row) {
        const sn = row.wtiSerialNumber;
        this.$confirm(
          this.$t("machine.rebootConfirm", { sn: sn, name: row.equipmentName || row.equipmentNo }),
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          this.wtiRebooting = sn;
          this.$api
            .request(this.$url.Machine.wtiReboot, this.$method.post, { sn: sn })
            .then(res => {
              this.wtiRebooting = null;
              if (res.code === 0) {
                this.$message.success(this.$t("machine.rebootQueued"));
              } else {
                this.$message.error(res.msg || this.$t("machine.rebootFailed"));
              }
            })
            .catch(() => {
              this.wtiRebooting = null;
              this.$message.error(this.$t("machine.rebootFailed"));
            });
        }).catch(() => {});
      },
      editWtiDescription(row) {
        const sn = row.wtiSerialNumber;
        const info = this.wtiInfoMap[sn];
        this.$prompt(this.$t("machine.wtiDescriptionTip"), this.$t("machine.wtiDescription"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          inputValue: (info && info.description) || ""
        }).then(({ value }) => {
          const description = (value || "").trim();
          this.$api
            .request(this.$url.Machine.wtiDescription, this.$method.put, { sn: sn, description: description })
            .then(res => {
              if (res.code === 0) {
                if (info) {
                  this.$set(info, "description", description);
                }
                this.$message.success(this.$t("common.success"));
              } else {
                this.$message.error(res.msg || this.$t("machine.wtiDescriptionFailed"));
              }
            });
        }).catch(() => {});
      },
      wtiSimAction(row, sim) {
        const action = sim.status === "Active" ? "deactivate" : "activate";
        const label = action === "deactivate" ? this.$t("machine.simDeactivate") : this.$t("machine.simActivate");
        this.$confirm(
          `${label} ${sim.carrier || "SIM" + sim.slot} (${sim.number}) — ${row.equipmentName || row.equipmentNo}?`,
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          this.$api
            .request(this.$url.Machine.wtiSimAction, this.$method.post, {
              sim: sim.number,
              action: action,
              notes: `via VTM portal for machine ${row.equipmentNo}`
            })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("machine.simActionQueued"));
              } else if (res.msg) {
                this.$message.error(res.msg);
              }
            });
        }).catch(() => {});
      },
      wtiEsimAction(row, sim, action) {
        const label = action === "deactivate" ? this.$t("machine.esimDeactivate") : this.$t("machine.esimActivate");
        this.$confirm(
          `${label} (EID ${sim.number}) — ${row.equipmentName || row.equipmentNo}?`,
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          this.$api
            .request(this.$url.Machine.wtiEsimAction, this.$method.post, {
              eid: sim.number,
              action: action,
              notes: `via VTM portal for machine ${row.equipmentNo}`
            })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("machine.simActionQueued"));
              } else if (res.msg) {
                this.$message.error(res.msg);
              }
            });
        }).catch(() => {});
      },
      loadWtiInfo() {
        this.machineList.forEach(row => {
          const sn = row.wtiSerialNumber;
          if (!sn || this.wtiInfoMap[sn] !== undefined) {
            return;
          }
          this.$api
            .request(this.$url.Machine.wtiInfo, this.$method.get, { sn: sn })
            .then(res => {
              this.$set(this.wtiInfoMap, sn, res.code === 0 && res.data ? res.data : null);
            })
            .catch(() => {
              this.$set(this.wtiInfoMap, sn, null);
            });
        });
      },
      editWtiSerial(row) {
        this.$prompt(this.$t("machine.wtiSerialTip"), this.$t("machine.wtiSerial"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          inputValue: row.wtiSerialNumber || "",
          inputPattern: /^[0-9]*$/,
          inputErrorMessage: this.$t("machine.wtiSerialInvalid")
        }).then(({ value }) => {
          const serial = (value || "").trim();
          this.$api
            .request(this.$url.Machine.updateWtiSerial, this.$method.put, {
              id: row.id,
              wtiSerialNumber: serial
            })
            .then(res => {
              if (res.code === 0) {
                row.wtiSerialNumber = serial || null;
                if (serial && this.wtiInfoMap[serial] === undefined) {
                  this.loadWtiInfo();
                }
                this.$message.success(this.$t("common.success"));
              }
            });
        }).catch(() => {});
      },
      addMachine() {
        this.dialogMachine = true;
        this.addOrEdit = true;
      },
      importSuccess(result) {
        if (result.success > 0) {
          this.currentChange();
        }
      },
      // 回收设备
      recoverMachine() {
        this.$confirm(this.$t("machine.recycle"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.recover, this.$method.put, {
              ids: this.$cloud.getIds(this.multipleSelection)
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      cancel(dialog, state) {
        this.dialogMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      // 编辑设备
      editMachine(row) {
        this.dialogMachine = true;
        this.addOrEdit = false;
        Object.keys(this.machine).forEach(key => {
          this.machine[key] = row[key];
        });
        this.machine.id = row.id;
      },
      openExtendDialog(row) {
        this.extendTarget = { equipmentNo: row.equipmentNo, equipmentName: row.equipmentName };
        this.extendDate = null;
        this.extendDatePart = "";
        this.extendTimePart = "00:00:00";
        this.dialogExtend = true;
        console.log('[Extend] Dialog opened for', row.equipmentNo);
      },
      onDatePartChange() {
        if (this.extendDatePart) {
          this.extendDate = this.extendDatePart + ' ' + (this.extendTimePart || '00:00:00');
          console.log('[Extend] date assembled:', this.extendDate);
        }
      },
      confirmExtend() {
        this.extendLoading = true;
        this.$api
          .request(this.$url.Machine.extendSubscription, this.$method.put, {
            equipmentNo: this.extendTarget.equipmentNo,
            expireDate: this.extendDate
          })
          .then(res => {
            this.extendLoading = false;
            if (res.code === 0) {
              this.$notify({ title: this.$t("common.tip"), message: `Subscription expiry set to ${this.extendDate}`, type: "success" });
              this.dialogExtend = false;
              this.currentChange(this.page.pageIndex);
            }
          })
          .catch(() => { this.extendLoading = false; });
      },
      // 删除设备
      delMachine(row) {
        this.$confirm(this.$t("machine.delete"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.delete, this.$method.delete, {
              id: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t("machine.deleteS"),
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      }
    }
  };
</script>

<style>
.extend-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.extend-modal-box {
  background: var(--vtm-surface);
  border-radius: 4px;
  width: 420px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  overflow: hidden;
}
.extend-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--vtm-line);
  font-size: 16px;
  font-weight: 600;
  color: var(--vtm-ink);
}
.extend-modal-close {
  cursor: pointer;
  color: var(--vtm-ink-2);
  font-size: 16px;
}
.extend-modal-close:hover { color: var(--vtm-ink); }
.extend-modal-body {
  padding: 20px;
}
.extend-modal-footer {
  padding: 12px 20px;
  border-top: 1px solid var(--vtm-line);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.extend-date-input {
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--vtm-line-2);
  border-radius: 4px;
  font-size: 14px;
  color: var(--vtm-ink);
  outline: none;
  box-sizing: border-box;
}
.extend-date-input:focus { border-color: var(--vtm-mint); }
.extend-btn-cancel {
  height: 32px;
  padding: 0 16px;
  border: 1px solid var(--vtm-line);
  border-radius: 4px;
  background: var(--vtm-surface);
  color: var(--vtm-ink-2);
  font-size: 14px;
  cursor: pointer;
}
.extend-btn-confirm {
  height: 32px;
  padding: 0 16px;
  border: none;
  border-radius: 4px;
  background: var(--vtm-mint);
  color: var(--vtm-mint-ink);
  font-size: 14px;
  cursor: pointer;
}
.extend-btn-confirm:disabled { background: var(--vtm-mint-dim); cursor: not-allowed; }
</style>
